import { FlightSeatMapRowFragment, SeatComfort } from '@websky/graphql';

import { SeatMapGroup } from '../model/types';
import { getGroupServices } from './getGroupServices';
import { getIsFreeSeat } from './getIsFreeSeat';
import { getSeatCombinedWith } from './getSeatCombinedWith';

export function splitRowsByGroups(rows: FlightSeatMapRowFragment[]): SeatMapGroup[] {
	const groupMap = new Map<string, FlightSeatMapRowFragment[]>();

	// Find first available comfort
	let comfort: SeatComfort = rows[0]?.seats?.[0]?.seatService?.comfort ?? null;

	if (!comfort) {
		comfort =
			rows.find(row => row.seats?.find(seat => seat?.seatService?.comfort))?.seats?.[0]?.seatService?.comfort ??
			SeatComfort.Standard;
	}

	// Split rows by groups
	let groupIndex = 0;

	rows.forEach(row => {
		const rowComfort = row.seats?.[0]?.seatService?.comfort;

		if (rowComfort && rowComfort !== comfort) {
			comfort = rowComfort;
			groupIndex += 1;
		}

		const key = `${comfort}-${groupIndex}`;

		groupMap.set(key, [...(groupMap.get(key) ?? []), row]);
	});

	return [...groupMap.values()].map(rows => ({
		services: getGroupServices(rows),
		rows: rows.map(row => ({
			...row,
			seats:
				row.seats?.map((seat, index) => ({
					...seat,
					isFree: getIsFreeSeat(seat),
					combinedWith: getSeatCombinedWith(seat, row.seats, index)
				})) ?? []
		}))
	}));
}
